import {NgModule} from '@angular/core';
import {ContactFormComponent} from "@iw-shop/contact/components/contact-form/contact-form.component";
import {AsyncPipe, CommonModule, JsonPipe, NgForOf, NgIf, NgSwitchCase, NgTemplateOutlet} from "@angular/common";
import {ReactiveFormsModule} from "@angular/forms";
import {MyFormsModule} from "@iw-shop/forms/my-forms.module";
import {CaptchaModule} from "@iw-shop/captcha/captcha.module";
import {ContactDynamicComponent} from "@iw-shop/contact/components/contact-dynamic/contact-dynamic.component";
import {RouterLink} from "@angular/router";
import {CoreModule} from "@iw-shop/core/core.module";

@NgModule({
    declarations: [
        ContactFormComponent,
        ContactDynamicComponent
    ],
    imports: [
        NgIf,
        CommonModule,
        ReactiveFormsModule,
        MyFormsModule,
        CaptchaModule,
        NgForOf,
        AsyncPipe,
        RouterLink,
        NgTemplateOutlet,
        JsonPipe,
        NgSwitchCase,
        CoreModule

    ],
    exports: [
        ContactFormComponent,
        ContactDynamicComponent
    ]
})
export class ContactModule {
}
